let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7LHhn")).then(() => parcelRequire('iDj6c'));